'use strict'

const isDebug = process.env.NODE_ENV === 'development'
if (isDebug) {
  console.log('development mode')
}
const host = isDebug ? 'http://localhost:9101' : ''

export default {
  secret: 'b@yondlink1203',
  apiHost: host,
  storageKeys: {
    user: 'USER',
    userRemembered: 'REMBERED_USER'
  }
}



// WEBPACK FOOTER //
// ./src/config.js